import ClubFeeCategory from './ClubFeeCategory.js';
import Department from './Department.js';
import PriceHistory from './PriceHistory.js';
import PricePerTime from './PricePerTime.js';

export default class ClubFee {

    static fromData(data) {
        if (!data) {
            return;
        }

        let priceHistory = null;
        if (null !== data.priceHistory && null !== data.priceHistory.data) {
            priceHistory = PriceHistory.fromData(data.priceHistory.data);
        }

        let clubFee = new ClubFee();
        clubFee.id = data.id;
        clubFee.name = data.name;
        clubFee.note = data.note;
        clubFee.paymentApproach = data.paymentApproach;
        clubFee.isArchived = data.isArchived;
        clubFee.department = null !== data.department ? Department.fromData(data.department) : null;
        clubFee.category = null !== data.category ? ClubFeeCategory.fromData(data.category) : null;
        clubFee.impersonalAccount = null;
        clubFee.invoiceTemplateType = data.invoiceTemplateType;
        if (null !== data.impersonalAccount) {
            clubFee.impersonalAccount = {
                id: data.impersonalAccount ? data.impersonalAccount.id : null,
                number: data.impersonalAccount ? data.impersonalAccount.number : null,
                label: data.impersonalAccount ? data.impersonalAccount.label : null,
            };
        }
        clubFee.basePrice = null;
        if (null !== priceHistory) {
            clubFee.basePrice = priceHistory.basePrice;
        }
        clubFee.priceHistory = priceHistory;
        clubFee.rollingIntervalType = data.rollingIntervalType;

        Object.seal(clubFee);
        return clubFee;
    }

    static fromDataForSalesListOfferingItem(data) {
        if (!data) {
            return;
        }

        let clubFee = new ClubFee();
        clubFee.id = data.id;
        clubFee.name = data.name;
        clubFee.paymentApproach = data.paymentApproach;
        clubFee.category = null !== data.category ? ClubFeeCategory.fromData(data.category) : null;
        clubFee.pricePerTime = PricePerTime.fromData(data.pricePerTime.data);

        return clubFee;
    }

    displayNameWithCategoryAndDepartment() {
        const parts = [];

        if (this.category) {
            parts.push(this.category.name);
        }

        if (this.department) {
            parts.push(this.department.name);
        }

        if (parts.length > 0) {
            return `${this.name} (${parts.join(' / ')})`;
        }

        return this.name;
    }
}
